import { HsVector3 } from '../objects/vector3.class';

export namespace HsHypersceneConstants {
  /**
   * Handles pi.
   */
  export const PI: number = Math.PI;

  /**
   * Handles pi mul 2.
   */
  export const PI_MUL_2: number = Math.PI * 2;

  /**
   * Handles pi div 2.
   */
  export const PI_DIV_2: number = Math.PI / 2;

  /**
   * Handles pi div 4.
   */
  export const PI_DIV_4: number = Math.PI / 4;

  /**
   * Handles deg 2 rad.
   */
  export const DEG_2_RAD: number = PI / 180;

  /**
   * Handles rad 2 deg.
   */
  export const RAD_2_DEG: number = 180 / PI;
  /**
   * Handles zero vector3.
   */
  export const ZERO_VECTOR3: Readonly<HsVector3> = HsVector3.makeZeroVector();

  /**
   * Handles identity vector3.
   */
  export const IDENTITY_VECTOR3: Readonly<HsVector3> = HsVector3.makeIdentityVector();
}
